import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import * as Highcharts from "highcharts";
import { DashboardDirectionJuridiqueService } from "../../core/service/dashboard-direction-juridique.service";
import { ChartViewDTO } from "../../core/model/chart_view/chart-view-dto";
import { SlaProduitDTO } from "../../core/model/sla-produit-dto";
import { DurationByProduitDTO } from "../../core/model/duration-by-produit-dto";
import { DurationByTaskDTO } from "../../core/model/duration-by-task-dto";

@Component({
  selector: "app-jur-qos",
  templateUrl: "./jur-qos.component.html",
  styleUrls: ["./jur-qos.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class JurQosComponent implements OnInit {
  highcharts = Highcharts;
  chartOptionsSlaTacheParProduit: any;
  chartOptionsSlaPeriodeParProduit: any;
  chartOptionsSlaPeriodeParProfile: any;

  slaTacheParProduit: ChartViewDTO;
  slaPeriodeParProduit: ChartViewDTO;
  slaPeriodeParProfile: ChartViewDTO;

  //slaProduitDTOs: SlaProduitDTO[];

  durationByProduitDTOs: DurationByProduitDTO[];
  displayedProduitColumnsList: string[] = [
    "codeProduit",
    "duration",
    "actions",
  ];
  durationByTaskDTOs: DurationByTaskDTO[];
  durationByTaskDTOArray: Array<DurationByTaskDTO[]> = [];

  constructor(
    private _dashboardDirectionJuridiqueService: DashboardDirectionJuridiqueService
  ) {}

  ngOnInit() {
    //this.getSlaTacheParProduit();
    this.getSlaPeriodeParProduit();
    this.getSlaPeriodeParProfile();
    //this.getSlaProduit();
    this.durationProduit();
  }

  getSlaPeriodeParProduit() {
    this._dashboardDirectionJuridiqueService
      .slaPeriodeParProduit()
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaPeriodeParProduit = response;

          this.chartOptionsSlaPeriodeParProduit = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement par produit",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.slaPeriodeParProduit.categories,
            },
            yAxis: {
              title: {
                text: "Jours",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.slaPeriodeParProduit.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getSlaPeriodeParProfile() {
    this._dashboardDirectionJuridiqueService
      .slaPeriodeParProfile()
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaPeriodeParProfile = response;

          this.chartOptionsSlaPeriodeParProfile = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement par profil",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.slaPeriodeParProfile.categories,
            },
            yAxis: {
              title: {
                text: "Jours",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.slaPeriodeParProfile.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /*getSlaTacheParProduit() {
    this._dashboardDirectionJuridiqueService
      .slaTacheParProduit()
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaTacheParProduit = response;

          this.chartOptionsSlaTacheParProduit = {
            chart: {
              type: "bar",
            },
            title: {
              text: "SLA tâches par produit",
            },
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },
            xAxis: {
              categories: this.slaTacheParProduit.categories,
              title: {
                text: null,
              },
            },
            yAxis: {
              min: 0,
              title: {
                text: "Jours",
                align: "high",
              },
              labels: {
                overflow: "justify",
              },
            },
            tooltip: {
              valueSuffix: "",
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  enabled: true,
                },
                showInLegend: true,
              },
              series: {
                stacking: "normal",
              },
            },
            credits: {
              enabled: false,
            },
            series: this.slaTacheParProduit.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }*/

  /*getSlaProduit() {
    this._dashboardDirectionJuridiqueService
      .slaProduit()
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaProduitDTOs = response;
        },
        (error) => {
          console.log(error);
        }
      );
  }*/

  durationProduit() {
    this._dashboardDirectionJuridiqueService.durationProduit().subscribe(
      (data) => {
        this.durationByProduitDTOs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  durationTask(codeProduit) {
    this._dashboardDirectionJuridiqueService
      .durationTask(codeProduit)
      .subscribe(
        (data) => {
          this.durationByTaskDTOs = data;
          this.durationByTaskDTOArray[codeProduit] = this.durationByTaskDTOs;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
